export default function domainDictionary(value) {
    let ytRegEx = /^(.+\.)?(youtube\.com|youtu\.be)$/i;
    let instagramRegEx = /^(.+\.)?(instagram)$/i;
    let fbRegEx = /^(.+\.)?(facebook\.com|fb\.com)$/i;
    let vkRegEx = /^(.+\.)?(vkontakte\.com|vk\.com)$/i;
    let twitterRegEx = /^(.+\.)?(twitter\.com|t\.co|x\.com)$/i;
    let dailyRegEx = /^(.+\.)?(dailymotion\.com|dai\.ly)$/i;
    let vimeoRegEx = /^(.+\.)?(vimeo\.com)$/i;
    let soundcloudRegEx = /^(.+\.)?(soundcloud\.com)$/i;
    let okRegEx = /^(.+\.)?(ok\.ru|odnoklassniki\.ru)$/i;
    let tiktokRegEx = /^(.+\.)?(tiktok\.com)$/i;
    let hotstarRegEx = /^(.+\.)?(hotstar\.com)$/i;
    let searchRegEx = /^(.+\.)?(google\.com|yandex\.ru|ya\.ru|bing\.com)$/i;
    let bitRegEx = /^(.+\.)?(bit\.ly)$/i;
    let pornRegEx = /^(.+\.)?(xvideos\.com|xnxx\.com|pornhub\.com|youporn\.com|xhamster\.com|spankbang\.com|xvideos[0-9]+\.com|txxx\.com|anybunny\.tv|redtube\.com|xnxx\.tv|pornhubpremium\.com|iporntv\.net)$/i;

    if (instagramRegEx.test(value) || String(value).indexOf('instagram') >= 0) {
        value = 'in'
    } else if (ytRegEx.test(value) || value === 101) {
        value = 101;
    } else if (fbRegEx.test(value) || String(value).indexOf('facebook') >= 0 || String(value).indexOf('fb') >= 0) {
        value = 'fa'
    } else if (vkRegEx.test(value) || String(value).indexOf('vkontakte') >= 0 || String(value).indexOf('vk') >= 0) {
        value = 'vk'
    } else if (twitterRegEx.test(value) || String(value).indexOf('twitter') >= 0 || String(value).indexOf('t.co') >= 0 || String(value).indexOf('x.com') >= 0){
        value = 'tw'
    } else if (dailyRegEx.test(value) || String(value).indexOf('dai') >= 0) {
        value = 'da'
    } else if (vimeoRegEx.test(value) || String(value).indexOf('vimeo') >= 0) {
        value = 'vi'
    } else if (soundcloudRegEx.test(value) || String(value).indexOf('soundcloud') >= 0) {
        value = 'so'
    } else if (okRegEx.test(value)) {
        value = 'ok'
    } else if (tiktokRegEx.test(value) || String(value).indexOf('tiktok') >= 0) {
        value = 'ti'
    } else if (hotstarRegEx.test(value) || String(value).indexOf('hotstar') >= 0) {
        value = 'ho'
    } else if (searchRegEx.test(value) || String(value).indexOf('google') >= 0 || String(value).indexOf('yandex') >= 0 || String(value).indexOf('ya') >= 0 || String(value).indexOf('bing') >= 0) {
        value = 'se'
    } else if (bitRegEx.test(value) || String(value).indexOf('bit') >= 0) {
        value = 'ls'
    } else if (pornRegEx.test(value) ||
        String(value).indexOf('xvideos') >= 0 ||
        String(value).indexOf('xnxx') >= 0 ||
        String(value).indexOf('pornhub') >= 0 ||
        String(value).indexOf('youporn') >= 0 ||
        String(value).indexOf('xhamster') >= 0 ||
        String(value).indexOf('spankbang') >= 0 ||
        String(value).indexOf('txxx') >= 0 ||
        String(value).indexOf('anybunny') >= 0 ||
        String(value).indexOf('redtube') >= 0 ||
        String(value).indexOf('xnxx') >= 0 ||
        String(value).indexOf('iporntv') >= 0) {
        value = 'xxx'
    } else {
        value = 'other';
    }

    return value;
}
